export default __webpack_public_path__ + "static/media/mos-user.32222800.svg";